import axios from 'axios';
import { FundManagerPhotoData } from 'funds-model';

export interface FundPhoto {
  photoBase64: string,
  photoAlt?: string,
  photoContentType?: string,
}

export const getFundPhoto = (fundId: number): Promise<FundPhoto> => {
  return axios.get<FundPhoto>('/api/faq/fund-photo', {
    params: {
    fundId,
  }}).then(response => response.data);
};

export const getFundManagerPhoto = (peopleIds: string, language = 'pl'): Promise<FundManagerPhotoData[]> => {
  return axios.get<FundManagerPhotoData[]>('/api/faq/people', { params: {
    peopleIds,
    language
  }}).then(response => response.data);
};

